import {IBizRedEnvelope, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {ARedEnvelope} from "@/views/editor/service/red_envelope/red_envelope";
import {EVipLevel} from "@/model/user_agent";
import {ERedEnvelopeType} from "@/views/editor/service/types";

export interface IRedEnvelopeSetMeta {
    amount: number[];
    limit_pre_day: number;
}

export interface IRedEnvelopeMeta {
    sets: Record<ERedEnvelopeType, IRedEnvelopeSetMeta>;
    area_limit: string[];
}

export default class RedEnvelope extends ARedEnvelope implements IBizRedEnvelope {
    readonly opt: IRedEnvelopeMeta

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as IRedEnvelopeMeta;
    }

    subs(status: EActivityStatus): CheckboxOptionType[] {
        if (this.editor.userAgent.authorizer().grant(EVipLevel.Professional)) return {
            active: [{value: 'view', label: '浏览红包'}, {value: 'invite', label: '邀请红包'}],
            preheating: [{value: 'view', label: '浏览红包'}, {value: 'invite', label: '邀请红包'}],
            finished: []
        }[status]
        else return []
    }

    resetMeta(status: EActivityStatus): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs(status).map(s => s.value as string))

        const opt: IRedEnvelopeMeta = {
            area_limit: [], sets: {
                invite: {
                    amount: [0.3, 1],
                    limit_pre_day: 10
                }, view: {
                    amount: [0.3, 1],
                    limit_pre_day: 10
                }
            }
        }
        Object.assign(this.opt, opt)
        return this;
    }

    destructor() {
        super.destructor();
        console.log('红包被析构')
    }
}